import type { ShopifyAsset } from '~/modules/shopify/types';
import type { IThemePagesMap } from '~/stores/themePage';

import { getThemePageIDBySuffix, validThemePageID } from '~/modules/campaign/utils';
import { parseLabelTemplate, parseTemplateInfoBy } from '~/utils';
import { ETemplateStatus } from '../types/template-status';
import { ProviderSource } from '~/types/template';

export interface DetermineTemplateStatusParams {
  templateSuffix: string;
  assets: ShopifyAsset[];
  themePages: IThemePagesMap;
  themePageId?: string;
}

export const checkTemplateInAssets = (templateSuffix: string, assets: ShopifyAsset[]): boolean => {
  return assets.some((asset) => asset.key === templateSuffix);
};

export const determineTemplateStatus = ({
  templateSuffix,
  assets,
  themePages,
  themePageId,
}: DetermineTemplateStatusParams) => {
  const isTemplateInAssets = checkTemplateInAssets(templateSuffix, assets);
  const templateInfo = parseTemplateInfoBy({
    templateSuffix,
    themePages: Object.values(themePages),
  });
  const isGPV7 = templateInfo?.providerSource === ProviderSource.GEMPAGESV7;
  const templateLabel = parseLabelTemplate(templateInfo);
  const isShopify = !isGPV7;
  const resolvedThemePageId = themePageId ?? getThemePageIDBySuffix(templateSuffix);

  if (isTemplateInAssets) {
    return { status: ETemplateStatus.NORMAL };
  }

  if (isShopify) return { status: ETemplateStatus.DELETED, label: templateLabel };

  const themePage = validThemePageID(resolvedThemePageId)
    ? themePages[resolvedThemePageId]
    : undefined;
  const label = themePage?.name ?? templateLabel;

  if (!themePage) {
    return { status: ETemplateStatus.DELETED, label };
  }

  return { status: ETemplateStatus.UNPUBLISHED, label };
};
